import { render } from "./NotFound.vue?vue&type=template&id=4c0d2780&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=4c0d2780&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.6.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0d2780"]])

export default __exports__